import React from 'react';
import PropTypes from 'prop-types';
import Font from '@mui/icons-material/HowToReg';
import { Card, Typography, IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { Grid, Table, TableCell, TableBody, TableRow, TableHead } from '@mui/material';
import ApprovalTypeLevelUserGroupListItemComponent from './ApprovalTypeLevelUserGroupListItemComponent';
import { getErrors } from '@totalsoft/pure-validations-react';

const ApprovalTypeLevelUserGroupListComponent = ({ approvalTypeLevelUserGroups, userGroups, dispatch, validation }) => {
  const { t } = useTranslation();
  const onAdd = collection => {
    const key = 'approvalTypeUserGroupId';
    dispatch({
      type: 'onAddApprovalTypeUserGroup',
      key,
      collection
    });
  };

  return (
    <Card
      icon={Font}
      iconColor='primary'
      title={t('ApprovalTypes.ApprovalTypeLevelUserGroup.GeneralData')}
      subheader={<Typography color='error'>{validation |> getErrors}</Typography>}
      actions={
        <IconButton
          type='add'
          fontSize='medium'
          color='transparent'
          tooltip={t('Tooltips.Add')}
          onClick={() => onAdd('approvalTypeUserGroups')}
        />
      }
    >
      <Grid item>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('ApprovalTypes.ApprovalTypeLevelUserGroup.UserGroup')}</TableCell>
              <TableCell>{t('ApprovalTypes.ApprovalTypeLevelUserGroup.Default')}</TableCell>
              <TableCell align='right'>{t('ApprovalTypes.ApprovalTypeLevelUserGroup.Actions')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {approvalTypeLevelUserGroups.map((item, idx) => {
              return (
                <ApprovalTypeLevelUserGroupListItemComponent
                  item={item}
                  key={idx}
                  dispatch={dispatch}
                  index={idx}
                  userGroups={userGroups}
                  validation={validation[idx]}
                />
              );
            })}
          </TableBody>
        </Table>
      </Grid>
    </Card>
  );
};

ApprovalTypeLevelUserGroupListComponent.propTypes = {
  approvalTypeLevelUserGroups: PropTypes.array.isRequired,
  userGroups: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default ApprovalTypeLevelUserGroupListComponent;
